var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dialog,
      expression: "dialog"
    }],
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      "max-width": _vm.options.width
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        !_vm.rejection && _vm.cancel;
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.message,
      expression: "!!message"
    }],
    staticClass: "pa-3 text-h2 text-center red--text"
  }, [_vm._v(" Warning! ")]), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.message,
      expression: "!!message"
    }],
    staticClass: "pa-4 text-h6 text-center"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _c('v-card-actions', {
    staticClass: "py-4 px-8 justify-center"
  }, [_vm.rejection ? _c('v-btn', {
    staticClass: "text-none text-subtitle-1 font-weight-medium px-2",
    attrs: {
      "large": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.cancel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Cancel ")]) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }